import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  ContentChild,
  forwardRef,
  inject,
  Injector,
  Input,
  OnInit,
  signal,
  TemplateRef
} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';
import {MatIcon} from '@angular/material/icon';
import {MatDialog} from '@angular/material/dialog';
import {MultiSelect3DialogComponent} from './multi-select3-dialog/multi-select3-dialog.component';
import {ApiService} from '../../../modules/apiModule1/api/ApiService';
import {MAT_DIALOG_METHOD, MAT_DIALOG_SERVICE} from '../../../app.config';
import {CommonModule} from '@angular/common';
import {CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray} from '@angular/cdk/drag-drop';

@Component({
  selector: 'pas-multi-select3',
  templateUrl: './multi-select3.component.html',
  styleUrls: ['./multi-select3.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    MatIcon,
    CommonModule,
    CdkDropList,
    CdkDrag
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelect3Component),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiSelect3Component implements ControlValueAccessor, OnInit {
  @Input() title = 'Индекс'
  @Input() type = 'checkbox'
  @Input() options = {}
  @Input({required: true}) customDataService!: ApiService;
  @Input({required: true}) customDialogMethod!: string;
  @Input() filteredObjectName?: string;
  @ContentChild('listItem',{read: TemplateRef}) listItem: TemplateRef<any>|null = null;
  @ContentChild('dialogList',{read: TemplateRef}) template: TemplateRef<any>|null = null;
  workingItems = signal<{ id: number, name: string, selected?: boolean }[]>([])

  injector = inject(Injector);
  dialog = inject(MatDialog);
  cdr = inject(ChangeDetectorRef)
  searchTerm = signal('');



  filteredItems = computed(() => {
      if (this.type !== 'checkbox') {

        if (!this.searchTerm()) {
          return this.workingItems().filter(item => item.selected)
        } else {
          return this.workingItems().filter(item =>
            item.selected && item.name.toLowerCase().includes(this.searchTerm().toLowerCase()));
        }
      } else {
        if (!this.searchTerm()) {
          return this.workingItems().filter(item => item.selected)
        } else {
          return this.workingItems().filter(item =>
            item.selected && item.name.toLowerCase().includes(this.searchTerm().toLowerCase()));
        }
      }


    }
  );

  // Для передачи данных форме
  private onChange: (value: any) => void = () => {
  };
  private onTouched: () => void = () => {
  };

  writeValue(value: any[]): void {
    if(value===null) this.workingItems.set([])
    value && this.workingItems.set(value.map(i => ({...i, selected: true})) || []);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Опционально можно реализовать отключение компонента
  }


  isSelected(item: any): boolean {
    return this.workingItems().some(i => i.id === item.id);
  }


  protected readonly open = open;

  openDialog() {

    const dialogInjector = Injector.create({
      providers: [
        {provide: MAT_DIALOG_SERVICE, useValue: this.customDataService}, // Передаем другой сервис
        {provide: MAT_DIALOG_METHOD, useValue: this.customDialogMethod},
      ],
      parent: this.injector // Ссылка на родительский инжектор
    });

    this.dialog.open(MultiSelect3DialogComponent, {
      data: {
        items: this.type === 'radio' ? [this.workingItems()[0]] : this.workingItems(),
        filteredObjectName: this.filteredObjectName,
        type: this.type,
        options: this.options,
        template: this.template
      },
      panelClass: 'center-dialog',
      width: '80%',
      maxWidth: '600px',
      height: '80%',
      autoFocus: false,
      hasBackdrop: true,
      closeOnNavigation: true,
      restoreFocus: true,
      injector: dialogInjector

    })!.afterClosed().subscribe(result => {
      if (!result || !result.length) return;
      const resultMapped = result.map((i: IndexEntry) => ({...i, selected: true}))
      const resultByType = this.type !== 'radio' ? resultMapped : [resultMapped[0]];
      this.workingItems.set(resultByType);
      this.onChange(this.workingItems())
      this.cdr.markForCheck();
    })
  }

  removeItem(item: { id: number, name: string }) {
    this.workingItems.set(this.workingItems().filter(i => i.id !== item.id));
    this.onChange(this.workingItems())
    this.cdr.markForCheck();
  }

  ngOnInit() {
  }

  drop(event: CdkDragDrop<string[]>) {
    const arr = [...this.workingItems()];
    moveItemInArray(arr, event.previousIndex, event.currentIndex);
    this.workingItems.set(arr);
    this.onChange(this.workingItems())
    this.cdr.markForCheck();
  }
}
